import { capitalize } from 'lodash'
import type { User } from '@/features/users/types/user'
import type { AuditLog } from '../types/audit'
import { formatDate } from '@/utils/timeZoneUtils'

type MobileLogCardProps = {
  log: AuditLog
  logUser: User | undefined
}

export default function MobileLogCard({ log, logUser }: MobileLogCardProps) {
  return (
    <div
      key={log._id}
      className="rounded-md border bg-white p-4 flex flex-col gap-2 shadow-sm"
    >
      <div className="flex items-center justify-between">
        <span className="font-semibold text-sm text-gray-700">
          {capitalize(log.action)}
        </span>
        <span className="text-xs text-gray-500">
          {formatDate(log.timestamp, 'DD/MM/YYYY hh:mm A')}
        </span>
      </div>
      <div className="grid grid-cols-2 gap-2 text-xs text-gray-600">
        <span>
          <span className="font-medium">Entity:</span> {log.entity}
        </span>
        <span>
          <span className="font-medium">User:</span> {logUser?.name || '-'}
        </span>
      </div>
      {log.details && (
        <div className="bg-gray-50 rounded p-2 text-xs overflow-x-auto">
          <pre className="whitespace-pre-wrap break-words max-h-40 overflow-y-auto">
            {JSON.stringify(log.details, null, 2)}
          </pre>
        </div>
      )}
    </div>
  )
}
